module.exports = __webpack_public_path__ + "static/media/2-4-3_Spot_UV_Special_03.235f0333.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/2-4-3_Spot_UV_Special_03.jpg
// module id = 1730
// module chunks = 0